import { useTranslation } from "react-i18next";

export const PayoutsPage = () => {
  const { t } = useTranslation("sidebar");

  return <title>{`${t("tutor.payouts")} - Ximly`}</title>;
};
